module.exports = __webpack_public_path__ + "images/emoji/checkered_flag.f566cd55f39c0133e1d7.png";